import { Boot } from '@wangeditor/editor'

export const ATTACHMENT_MENU_KEY = 'uploadAttachment'

const ATTACHMENT_ICON = '<svg viewBox="0 0 1024 1024"><path d="M665.6 128 384 409.6c-66.2 66.2-66.2 173.4 0 239.6 66.2 66.2 173.4 66.2 239.6 0l302.4-302.4c93-93 93-243.8 0-336.8-93-93-243.8-93-336.8 0L213 446.6c-132.8 132.8-132.8 348.2 0 481 132.8 132.8 348.2 132.8 481 0l329.8-329.8c25.2-25.2 25.2-66 0-91.2-25.2-25.2-66-25.2-91.2 0L602.4 836.4c-83 83-217.4 83-300.4 0-83-83-83-217.4 0-300.4l362.2-362.2c58.6-58.6 153.6-58.6 212.2 0 58.6 58.6 58.6 153.6 0 212.2L497.4 767.2c-24.8 24.8-65 24.8-89.8 0-24.8-24.8-24.8-65 0-89.8L693.4 392"/></svg>'

let attachmentHandler = null
let initialized = false

export function setEditorAttachmentHandler(handler) {
  attachmentHandler = handler
}

class UploadAttachmentMenu {
  constructor() {
    this.title = '上传附件'
    this.iconSvg = ATTACHMENT_ICON
    this.tag = 'button'
  }

  getValue() {
    return ''
  }

  isActive() {
    return false
  }

  isDisabled() {
    return false
  }

  exec(editor) {
    if (attachmentHandler) {
      attachmentHandler(editor)
    }
  }
}

export function initWangEditorAttachmentMenu() {
  if (initialized) {
    return
  }
  Boot.registerMenu({
    key: ATTACHMENT_MENU_KEY,
    factory() {
      return new UploadAttachmentMenu()
    }
  })
  initialized = true
}
